import { render, staticRenderFns } from "./ListarAgrupadores.vue?vue&type=template&id=5045f242"
import script from "./ListarAgrupadores.vue?vue&type=script&lang=js"
export * from "./ListarAgrupadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5045f242')) {
      api.createRecord('5045f242', component.options)
    } else {
      api.reload('5045f242', component.options)
    }
    module.hot.accept("./ListarAgrupadores.vue?vue&type=template&id=5045f242", function () {
      api.rerender('5045f242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ListarAgrupadores.vue"
export default component.exports